export default __webpack_public_path__ + "static/media/solution_76.250a460d.svg";